import React, { useState } from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDBox, FDContentContainer, FDPrimaryActionButton } from '@facet-wealth/design';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PageHeader from 'Components/ComponentLibrary/Molecules/PageHeader';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import FileUploader from 'Components/Files/Uploader2';
import { CompleteActionItemBanner } from 'Components/ComponentLibrary/Organisms/CompleteActionItemBanner';
import { RichTextDisplay } from 'Packages/FacetDesign/Components';
import useMobileLayout from 'Hooks/useMobileLayout';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import categories from 'EventTracking/consts/categories';
import eventTypes from 'EventTracking/consts/eventTypes';
import eventSubTypes from 'EventTracking/consts/eventSubTypes';
import { getEventPropertiesForResourceLogging } from 'Helpers/logging';
import { dataAttrs } from 'Helpers/Testing';
import { NMARSRequestsMobile } from './mobile';
import { NMARSRequestsDesktop } from './desktop';

export const NMARSRequestsPageTemplate = ({ resource }) => {
  const [uploading, setUploading] = useState(false);
  const { refreshPageContentCollection } = usePageContentContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const isMobile = useMobileLayout();
  const DisplayComponent = isMobile ? NMARSRequestsMobile : NMARSRequestsDesktop;

  useBoneBackgroundColor();

  return (
    <>
      <CompleteActionItemBanner resource={resource} />
      <FDContentContainer maxWidth={'lg'} {...dataAttrs('nmars-page', resource)}>
        <FDBox paddingY={isMobile ? 2 : undefined}>
          <PageHeader
            title={resource.attr('title')}
            actions={resource.withRelationship(
              fr.relationships.addRequest.name,
              (rel) => (
                <FileUploader
                  url={rel.link('related').url()}
                  onStart={() => {
                    const eventProperties = getEventPropertiesForResourceLogging(resource);
                    logStandardizedEvent(categories.foundations, eventTypes.click, eventSubTypes.uploadingNmars, {
                      eventProperties,
                    });
                    setUploading(true);
                  }}
                  onSuccess={() => {
                    const eventProperties = getEventPropertiesForResourceLogging(resource);
                    logStandardizedEvent(categories.foundations, eventTypes.completed, eventSubTypes.uploadNmars, {
                      eventProperties,
                    });
                    refreshPageContentCollection();
                  }}
                  onFinally={() => {
                    setUploading(false);
                  }}
                  successToastMessage="File successfully uploaded"
                  params={null}
                >
                  <FDPrimaryActionButton loading={uploading} label={rel.meta('prompt')} icon={'upload'} />
                </FileUploader>
              ),
              () => null,
            )}
          />
          <RichTextDisplay value={resource.attr('description')} />
          {resource.attr('requests').resources().length() > 0 && <DisplayComponent resource={resource} />}
        </FDBox>
      </FDContentContainer>
    </>
  );
};

NMARSRequestsPageTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
